import React, { useState, useEffect, Fragment } from 'react';
import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
// import FormLabel from "@mui/material/FormLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import EastIcon from "@mui/icons-material/East";
import LoadingButton from '@mui/lab/LoadingButton';
import { FormControl, MenuItem, InputLabel, Select } from "@mui/material";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import moment from 'moment';

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import { styled } from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

import { useForm } from "react-hook-form";

import CameraAddMore from '../CameraAddMore';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Img = styled("img")({
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    height: 160,
});

const starStyle = {color:'red',fontWeight:'bold',marginLeft:'2px',marginBottom:'0px'};

export default function DocumentForm({ onSave, dataStep, saveAndBack, btnLoading }) {
    const [gender, setGender] = useState("");
    // const [birthday, setBirthday] = useState("");
    // const [is_punish, setIs_punish] = useState("1");
    // const [education_qual, setEducation_qual] = useState('');
    // const [educationList, setEducationList] = useState([
    //     "ต่ำกว่ามัธยมศึกษาตอนปลาย / ปวช.",
    //     "มัธยมศึกษาตอนปลาย / ปวช.",
    //     "อนุปริญญา / ปวส.",
    //     "ปริญญาตรี",
    //     "ปริญญาโท หรือสูงกว่า"
    // ]);

    const [imagesCarBook, setImagesCarBook] = React.useState([]);
    const [openCarBook, setOpenCarBook] = React.useState(false);
    const [has_carBook, setHas_carBook] = useState("1");

    const [imagesCarTax, setImagesCarTax] = React.useState([]);
    const [openCarTax, setOpenCarTax] = React.useState(false);
    const [has_carTax, setHas_carTax] = useState("1");

    const [imagesCarChassis, setImagesCarChassis] = React.useState([]);
    const [openCarChassis, setOpenCarChassis] = React.useState(false);
    const [has_carChassis, setHas_carChassis] = useState("1");
    
    const [imagesCarLicense, setImagesCarLicense] = React.useState([]);
    const [openCarLicense, setOpenCarLicense] = React.useState(false);
    const [has_carLicense, setHas_carLicense] = useState("1");

    const [previousData, setPreviousData] = useState(null);
    const [capturedImages, setCapturedImages] = useState(null);
    const [inputTextImagesData, setInputTextImagesData] = useState([]);
    const [inputObjIDImages, setInputObjIDImages] = useState([]);

    const { register, formState: { errors }, handleSubmit, setValue, reset } = useForm({});
    // const [user, setUser] = useState(null);

    function handleTextChange(e) {
      const { id, value } = e.target;
        // console.log("handleTextChange in Accessory", inputTextImagesData);
      // setInputTextImagesData(prev => ({ ...prev, [id]: value }));    // code นี้มันทำให้ค่า inputTextImagesData กลายเป็น object จึงใช้ไม่ได้
      // console.log("inputTextImagesData",inputTextImagesData);
      setInputTextImagesData(prev => {
          // แปลง id (ที่อาจเป็น string) ให้เป็นตัวเลขสำหรับใช้เป็น index
          const targetIndex = Number(id);

          // ใช้ (prev ?? []) เพื่อป้องกัน error หาก state เริ่มต้นเป็น null/undefined
          // .map() จะสร้าง array ใหม่เสมอ (หลักการ Immutability ของ React)
          return (prev ?? []).map((item, index) => {
            // ตรวจสอบว่าใช่ index ที่เราต้องการแก้ไขหรือไม่
            if (index === targetIndex) {
              // ถ้าใช่ ให้คืนค่า value ใหม่จาก TextChange
              return value;
            }
            // ถ้าไม่ใช่ index ที่ต้องการแก้ ก็คืนค่าเดิมไป
            return item;
          });
        });
    }

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        // reset form with previousData data
        reset(previousData);
    }, [previousData]);

    const onSubmit = (data) => {
        // console.log("onSubmit", data);
        // console.log("capturedImages",capturedImages);
        data.capturedImages = capturedImages;
        data.capturedTextImages = inputTextImagesData;
        data.capturedObjIDImages = inputObjIDImages;
            //// ในกรณีที่กดย้อนกลับมา แล้วกดไปต่อ โดยไม่ได้เปิด popup ขึ้นมาดู มันจะไม่ได้ set ค่า มี/ไม่มี ด้วย
            //// จึงทำการ set ค่าอีกครั้ง ก่อนจะ submit ค่าไป save
            data.has_carBook = has_carBook;
            data.has_carTax = has_carTax;
            data.has_carChassis = has_carChassis;
            data.has_carLicense = has_carLicense;

            // // console.log("imagesCarBook[0]", imagesCarBook[0]);
            // if(!imagesCarBook[0]){
            //     // console.log("if");
            //     alert("กรุณาถ่าย หรือ อัพโหลด รูปเล่มทะเบียน ก่อนไปยังขั้นตอนถัดไป");
            //     return;
            // }
            // // console.log("imagesCarTax[0]", imagesCarTax[0]);
            // if(!imagesCarTax[0]){
            //     // console.log("if");
            //     alert("กรุณาถ่าย หรือ อัพโหลด รูปป้ายภาษีรถยนต์ ก่อนไปยังขั้นตอนถัดไป");
            //     return;
            // }
            // // console.log("imagesCarChassis[0]", imagesCarChassis[0]);
            // if(!imagesCarChassis[0]){
            //     // console.log("if");
            //     alert("กรุณาถ่าย หรือ อัพโหลด รูปเลขตัวถัง ก่อนไปยังขั้นตอนถัดไป");
            //     return;
            // }
            if(!has_carBook){
                console.log("has_carBook has undefined");
                alert("กรุณาถ่าย หรือ อัพโหลด รูปเล่มทะเบียน ก่อนไปยังขั้นตอนถัดไป");
                return;
            }else if(has_carBook == 1){
                if(!imagesCarBook[0]){
                    console.log("images not have");
                    alert("กรุณาถ่าย หรือ อัพโหลด รูปเล่มทะเบียน ก่อนไปยังขั้นตอนถัดไป");
                    return;
                }
            }
            if(!has_carChassis){
                console.log("has_carChassis has undefined");
                alert("กรุณาถ่าย หรือ อัพโหลด รูปเลขตัวถัง ก่อนไปยังขั้นตอนถัดไป");
                return;
            }else if(has_carChassis == 1){
                if(!imagesCarChassis[0]){
                    console.log("images not have");
                    alert("กรุณาถ่าย หรือ อัพโหลด รูปเลขตัวถัง ก่อนไปยังขั้นตอนถัดไป");
                    return;
                }
            }

        onSave(data);
    };

    const handleCapture = (capturedImages) => {
        console.log("handleCapture",capturedImages);
        console.log("handleCapture dataStep",dataStep);
        setValue('capturedImages', capturedImages);
        setCapturedImages(capturedImages);
        console.log("handleCapture inputTextImagesData",inputTextImagesData);
        setInputTextImagesData((prev) => {
            const newObjImage = [...prev];
            // console.log("newObjImage",capturedImages.length,newObjImage);
            newObjImage[capturedImages.length-1] = ''; // ==> เอา default เป็น '' ไปก่อน
            return newObjImage;
        });
        //// ต้อง set default value สำหรับ objID ของรูปใหม่ด้วย ////
        console.log("handleCapture inputObjIDImages",inputObjIDImages);
        setInputObjIDImages((prev) => {
            const newObjImage = [...prev];
            // console.log("newObjImage",capturedImages.length,newObjImage);
            newObjImage[capturedImages.length-1] = ''; // ==> เอา default เป็น '' ไปก่อน
            return newObjImage;
        });
    }

    const handleRemoveImage = (index, newImages, newTextImages, newObjIDImages) => {
        console.log("handleRemoveImage index", index);
        console.log("newImages", newImages, "newTextImages", newTextImages,"inputObjIDImages",inputObjIDImages);
            console.log("type newTextImages", typeof newTextImages);
        setCapturedImages((newImages) => newImages.filter((_, i) => i !== index));
        // setInputTextImagesData(Object.values(newTextImages).filter(item => item !== newTextImages[index]));
        setInputTextImagesData((newTextImages) => newTextImages.filter((_, i) => i !== index));

            console.log("newTextImages",newTextImages);
            console.log("inputTextImagesData",inputTextImagesData);
        setInputObjIDImages((prev) => prev.filter((_, i) => i !== index));


        setValue('capturedImages', capturedImages);
        // setCapturedImages(newImages);
        // setValue('capturedTextImages', newTextImages);
        // setInputTextImagesData(newTextImages);
    }

  // function getValueTest() {
  //     console.log("getValueTest", capturedImages, inputTextImagesData);
  // }

    const handleBack = () => {
        // console.log("new handleBack", data);
        // console.log("capturedImages",capturedImages);
        // console.log("inputTextImagesData",inputTextImagesData);
        // console.log("handleBack datastep",dataStep);
        // setCapturedImages(dataStep.capturedImages);
        setCapturedImages(capturedImages);
        // setValue('imageSrc', imageSrc);
        // setValue('capturedImages', capturedImages);


        const data = { 
            capturedImages : capturedImages,
            capturedTextImages : inputTextImagesData,
            capturedObjIDImages : inputObjIDImages,
            imagesCarBook : imagesCarBook,
            imagesCarTax : imagesCarTax,
            imagesCarChassis : imagesCarChassis,
            imagesCarLicense : imagesCarLicense,
            has_carBook: has_carBook,
            has_carTax: has_carTax,
            has_carChassis: has_carChassis,
            has_carLicense: has_carLicense,
        }

        // console.log("will saveAndBack",data);
        saveAndBack(data);
    }

    function getData() {
        // console.log("getData",dataStep);
        if (dataStep !== "") {
            setPreviousData({
                capturedImages: dataStep.capturedImages,
                capturedTextImages: dataStep.capturedTextImages,
                capturedObjIDImages: dataStep.capturedObjIDImages,
                imagesCarBook: dataStep.imagesCarBook && dataStep.imagesCarBook.length > 0 ?
                                        [dataStep.imagesCarBook[0]] : null,
                imagesCarTax: dataStep.imagesCarTax && dataStep.imagesCarTax.length > 0 ?
                                        [dataStep.imagesCarTax[0]] : null,
                imagesCarChassis: dataStep.imagesCarChassis && dataStep.imagesCarChassis.length > 0 ?
                                        [dataStep.imagesCarChassis[0]] : null,
                imagesCarLicense: dataStep.imagesCarLicense && dataStep.imagesCarLicense.length > 0 ?
                                        [dataStep.imagesCarLicense[0]] : null,
    //             firstname: dataStep.firstname,
    //             lastname: dataStep.lastname,
    //             gender: dataStep.gender,
                has_carBook: dataStep.has_carBook,
                has_carTax: dataStep.has_carTax,
                has_carChassis: dataStep.has_carChassis,
                has_carLicense: dataStep.has_carLicense,
            })

            setCapturedImages(dataStep.capturedImages);
            setInputTextImagesData(dataStep.capturedTextImages);
            setInputObjIDImages(dataStep.capturedObjIDImages);
            if(dataStep.imagesCarBook && dataStep.imagesCarBook.length > 0){
                setImagesCarBook([dataStep.imagesCarBook[0]]);
            }
            if(dataStep.imagesCarTax && dataStep.imagesCarTax.length > 0){
                setImagesCarTax([dataStep.imagesCarTax[0]]);
            }
            if(dataStep.imagesCarChassis && dataStep.imagesCarChassis.length > 0){
                setImagesCarChassis([dataStep.imagesCarChassis[0]]);
            }
            if(dataStep.imagesCarLicense && dataStep.imagesCarLicense.length > 0){
                setImagesCarLicense([dataStep.imagesCarLicense[0]]);
            }

            setHas_carBook(dataStep.has_carBook !== null ? dataStep.has_carBook : "0");
            setHas_carTax(dataStep.has_carTax !== null ? dataStep.has_carTax : "0");
            setHas_carChassis(dataStep.has_carChassis !== null ? dataStep.has_carChassis : "0");
            setHas_carLicense(dataStep.has_carLicense !== null ? dataStep.has_carLicense : "0");
        }
    }


    function onImageChangeCarBook(event) {
        let files = event.target.files;
        console.log("files", files);
        if(files.length>0){
            let newArray = [];
            Array.from(files).forEach((file, index) => {
                console.log("file",file);

                let reader = new FileReader();
                reader.readAsDataURL(file);
                console.log("reader", reader);

                reader.onload = (e) => {
                    console.log("reader.onload", [e.target.result]);
                    // setImagesCarBook([e.target.result]);
                    // setValue('imagesCarBook', [e.target.result]);

                    newArray.push(e.target.result);
                    setImagesCarBook(newArray);
                    setValue('imagesCarBook', newArray);
                };
                console.log("newArray", newArray);
                // setImagesCarBook(newArray);
                // setValue('imagesCarBook', newArray);
            });
            // console.log("newArray", newArray);
        }
    }
    function onImageChangeCarBook_old(event) {
        let files = event.target.files;
        console.log("files", files);
        if(files.length>0){
            let reader = new FileReader();
            reader.readAsDataURL(files[0]);
            console.log("reader", reader);

            reader.onload = (e) => {
                setImagesCarBook([e.target.result]);
                setValue('imagesCarBook', [e.target.result]);
                console.log("imagesCarBook", imagesCarBook);
            };
            console.log("end onImageChangeCarBook_old");
        }
    }
    function onImageChangeCarTax(event) {
        let files = event.target.files;
        if(files.length>0){
            let reader = new FileReader();
            reader.readAsDataURL(files[0]);

            reader.onload = (e) => {
                setImagesCarTax([e.target.result]);
                setValue('imagesCarTax', [e.target.result]);
            };
        }
    }
    function onImageChangeCarChassis(event) {
        let files = event.target.files;
        if(files.length>0){
            let reader = new FileReader();
            reader.readAsDataURL(files[0]);

            reader.onload = (e) => {
                setImagesCarChassis([e.target.result]);
                setValue('imagesCarChassis', [e.target.result]);
            };
        }
    }
    function onImageChangeCarLicense(event) {
        let files = event.target.files;
        if(files.length>0){
            let reader = new FileReader();
            reader.readAsDataURL(files[0]);

            reader.onload = (e) => {
                setImagesCarLicense([e.target.result]);
                setValue('imagesCarLicense', [e.target.result]);
            };
        }
    }
    
    return (
        <React.Fragment>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={3}>

                {/* เล่มทะเบียนรถ */}
                <Grid
                    item xs={12} sm={12} container
                    direction="row" justifyContent="space-between"
                    alignItems="center" boxShadow={3}
                    sx={{ p: 3, mt: 3, ml: 2, cursor: "pointer",
                        backgroundColor: 
                            imagesCarBook.length > 0 ? "#73c088" 
                            : has_carBook == 0 ? "#73c088"
                            : null,
                    }}
                    onClick={() => setOpenCarBook(true)}
                >
                    <Box sx={{ display: "flex" }}>
                        <UploadFileIcon sx={{ mr: 3 }} />
                        <div>เล่มทะเบียนรถ</div>
                        {/*<p style={starStyle}>*</p>*/}
                    </Box>
                    {imagesCarBook.length > 0 ? <CheckIcon /> : <CloseIcon />}
                </Grid>
                <Dialog
                    open={openCarBook} TransitionComponent={Transition}
                    fullWidth={true} maxWidth="sm"
                    keepMounted
                    onClose={() => setOpenCarBook(false)}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>
                        <div>เล่มทะเบียนรถ</div>
                        <div variant="subtitle2" sx={{ color: "#FF0000" }} >
                            {/* radio มี / ไม่มี */}
                            <RadioGroup
                                aria-labelledby="radio-audio-equipment-buttons-group"
                                value={has_carBook}
                                name="radio-audio-equipment-buttons-group"
                                {...register("has_carBook")}
                            >
                                <FormControlLabel label="มี"
                                    onChange={(event) => setHas_carBook("1")} value="1" control={<Radio />}
                                />
                                <FormControlLabel label="ไม่มี"
                                    onChange={(event) => setHas_carBook("0")} value="0" control={<Radio />}
                                />
                            </RadioGroup>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                    {
                        has_carBook == 1?
                            <Grid container spacing={2}>
                                <Grid item md={12} sm={12} xs={12}>
                                    <Button color="primary" variant="outlined"
                                        aria-label="upload picture" component="label"
                                        sx={{ width: "100%", minHeight: 170, maxHeight: 170, }}
                                    >
                                        <input type="file" accept="image/*"
                                            hidden capture onChange={onImageChangeCarBook_old}
                                        />
                                        {imagesCarBook.length > 0 ? (
                                            imagesCarBook.map((item) => (<Img src={item} />))
                                        ) : (
                                            <PhotoCamera sx={{ fontSize: 60 }} />
                                        )}
                                    </Button>

                                    {/* 
                                    <TextField type="file" id="outlined-basic"
                                      label="Outlined" variant="outlined"
                                       onChange={onImageChangeCarBook}
                                      inputProps={{
                                        multiple: true
                                      }}
                                    /> */}

                                </Grid>
                            </Grid>
                        :null
                    }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            onClick={() => setOpenCarBook(false)}
                            endIcon={<EastIcon />}
                            sx={{ mt: 3, ml: 1 }}
                        >
                            บันทึก
                        </Button>
                    </DialogActions>
                </Dialog>


                {/* ป้ายภาษีรถยนต์ 
                <Grid
                    item xs={12} sm={12} container
                    direction="row" justifyContent="space-between"
                    alignItems="center" boxShadow={3}
                    sx={{ p: 3, mt: 3, ml: 2, cursor: "pointer",
                        backgroundColor: 
                            imagesCarTax.length > 0 ? "#73c088" 
                            : has_carTax == 0 ? "#73c088"
                            : null,
                    }}
                    onClick={() => setOpenCarTax(true)}
                >
                    <Box sx={{ display: "flex" }}>
                        <UploadFileIcon sx={{ mr: 3 }} />
                        <div>ป้ายภาษีรถยนต์</div>
                    </Box>
                    {imagesCarTax.length > 0 ? <CheckIcon /> : <CloseIcon />}
                </Grid>
                <Dialog
                    open={openCarTax} TransitionComponent={Transition}
                    fullWidth={true} maxWidth="sm"
                    keepMounted
                    onClose={() => setOpenCarTax(false)}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>
                        <div>ป้ายภาษีรถยนต์</div>
                        <div variant="subtitle2" sx={{ color: "#FF0000" }} >
                            <RadioGroup
                                aria-labelledby="radio-audio-equipment-buttons-group"
                                value={has_carTax}
                                name="radio-audio-equipment-buttons-group"
                                {...register("has_carTax")}
                            >
                                <FormControlLabel label="มี"
                                    onChange={(event) => setHas_carTax("1")} value="1" control={<Radio />}
                                />
                                <FormControlLabel label="ไม่มี"
                                    onChange={(event) => setHas_carTax("0")} value="0" control={<Radio />}
                                />
                            </RadioGroup>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                    {
                        has_carTax == 1?
                            <Grid container spacing={2}>
                                <Grid item md={12} sm={12} xs={12}>
                                    <Button color="primary" variant="outlined"
                                        aria-label="upload picture" component="label"
                                        sx={{ width: "100%", minHeight: 170, maxHeight: 170, }}
                                    >
                                        <input type="file" accept="image/*"
                                            hidden capture onChange={onImageChangeCarTax}
                                        />
                                        {imagesCarTax.length > 0 ? (
                                            imagesCarTax.map((item) => (<Img src={item} />))
                                        ) : (
                                            <PhotoCamera sx={{ fontSize: 60 }} />
                                        )}
                                    </Button>
                                </Grid>
                            </Grid>
                        :null
                    }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            onClick={() => setOpenCarTax(false)}
                            endIcon={<EastIcon />}
                            sx={{ mt: 3, ml: 1 }}
                        >
                            บันทึก
                        </Button>
                    </DialogActions>
                </Dialog>
                */}


                {/* เลขตัวถัง */}
                <Grid
                    item xs={12} sm={12} container
                    direction="row" justifyContent="space-between"
                    alignItems="center" boxShadow={3}
                    sx={{ p: 3, mt: 3, ml: 2, cursor: "pointer",
                        backgroundColor: 
                            imagesCarChassis.length > 0 ? "#73c088" 
                            : has_carChassis == 0 ? "#73c088"
                            : null,
                    }}
                    onClick={() => setOpenCarChassis(true)}
                >
                    <Box sx={{ display: "flex" }}>
                        <UploadFileIcon sx={{ mr: 3 }} />
                        <div>เลขตัวถัง</div>
                    </Box>
                    {imagesCarChassis.length > 0 ? <CheckIcon /> : <CloseIcon />}
                </Grid>
                <Dialog
                    open={openCarChassis} TransitionComponent={Transition}
                    fullWidth={true} maxWidth="sm"
                    keepMounted
                    onClose={() => setOpenCarChassis(false)}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>
                        <div>เลขตัวถัง</div>
                        <div variant="subtitle2" sx={{ color: "#FF0000" }} >
                            {/* radio มี / ไม่มี */}
                            <RadioGroup
                                aria-labelledby="radio-audio-equipment-buttons-group"
                                value={has_carChassis}
                                name="radio-audio-equipment-buttons-group"
                                {...register("has_carChassis")}
                            >
                                <FormControlLabel label="มี"
                                    onChange={(event) => setHas_carChassis("1")} value="1" control={<Radio />}
                                />
                                <FormControlLabel label="ไม่มี"
                                    onChange={(event) => setHas_carChassis("0")} value="0" control={<Radio />}
                                />
                            </RadioGroup>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                    {
                        has_carChassis == 1?
                            <Grid container spacing={2}>
                                <Grid item md={12} sm={12} xs={12}>
                                    <Button color="primary" variant="outlined"
                                        aria-label="upload picture" component="label"
                                        sx={{ width: "100%", minHeight: 170, maxHeight: 170, }}
                                    >
                                        <input type="file" accept="image/*"
                                            hidden capture onChange={onImageChangeCarChassis}
                                        />
                                        {imagesCarChassis.length > 0 ? (
                                            imagesCarChassis.map((item) => (<Img src={item} />))
                                        ) : (
                                            <PhotoCamera sx={{ fontSize: 60 }} />
                                        )}
                                    </Button>
                                </Grid>
                            </Grid>
                        :null
                    }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            onClick={() => setOpenCarChassis(false)}
                            endIcon={<EastIcon />}
                            sx={{ mt: 3, ml: 1 }}
                        >
                            บันทึก
                        </Button>
                    </DialogActions>
                </Dialog>


                {/* ใบอนุญาตขับขี่ / บัตรประชาชน 
                <Grid
                    item xs={12} sm={12} container
                    direction="row" justifyContent="space-between"
                    alignItems="center" boxShadow={3}
                    sx={{ p: 3, mt: 3, ml: 2, cursor: "pointer",
                        backgroundColor: 
                            imagesCarLicense.length > 0 ? "#73c088" 
                            : has_carLicense == 0 ? "#73c088"
                            : null,
                    }}
                    onClick={() => setOpenCarLicense(true)}
                >
                    <Box sx={{ display: "flex" }}>
                        <UploadFileIcon sx={{ mr: 3 }} />
                        <div>ใบอนุญาตขับขี่ / บัตรประชาชน</div>
                    </Box>
                    {imagesCarLicense.length > 0 ? <CheckIcon /> : <CloseIcon />}
                </Grid>
                <Dialog
                    open={openCarLicense} TransitionComponent={Transition}
                    fullWidth={true} maxWidth="sm"
                    keepMounted
                    onClose={() => setOpenCarLicense(false)}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>
                        <div>ใบอนุญาตขับขี่ / บัตรประชาชน</div>
                        <div variant="subtitle2" sx={{ color: "#FF0000" }} >
                            <RadioGroup
                                aria-labelledby="radio-audio-equipment-buttons-group"
                                value={has_carLicense}
                                name="radio-audio-equipment-buttons-group"
                                {...register("has_carLicense")}
                            >
                                <FormControlLabel label="มี"
                                    onChange={(event) => setHas_carLicense("1")} value="1" control={<Radio />}
                                />
                                <FormControlLabel label="ไม่มี"
                                    onChange={(event) => setHas_carLicense("0")} value="0" control={<Radio />}
                                />
                            </RadioGroup>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                    {
                        has_carLicense == 1?
                            <Grid container spacing={2}>
                                <Grid item md={12} sm={12} xs={12}>
                                    <Button color="primary" variant="outlined"
                                        aria-label="upload picture" component="label"
                                        sx={{ width: "100%", minHeight: 170, maxHeight: 170, }}
                                    >
                                        <input type="file" accept="image/*"
                                            hidden capture onChange={onImageChangeCarLicense}
                                        />
                                        {imagesCarLicense.length > 0 ? (
                                            imagesCarLicense.map((item) => (<Img src={item} />))
                                        ) : (
                                            <PhotoCamera sx={{ fontSize: 60 }} />
                                        )}
                                    </Button>
                                </Grid>
                            </Grid>
                        :null
                    }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            onClick={() => setOpenCarLicense(false)}
                            endIcon={<EastIcon />}
                            sx={{ mt: 3, ml: 1 }}
                        >
                            บันทึก
                        </Button>
                    </DialogActions>
                </Dialog>
                */}


                    {/*
                    <Grid item xs={12} sm={12}>
                        <FormControlLabel label="เล่มทะเบียนรถ"
                            control={<Checkbox {...register("car_book")} id="car_book" />} 
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControlLabel label="ป้ายภาษีรถยนต์"
                            control={<Checkbox {...register("car_tax")} id="car_tax" />} 
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControlLabel label="เลขตัวถัง"
                            control={<Checkbox {...register("car_chassis")} id="car_chassis" />} 
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControlLabel label="ใบอนุญาตขับขี่ / บัตรประชาชน"
                            control={<Checkbox {...register("car_license")} id="car_license" />} 
                        />
                    </Grid>
                    */}


                    {/*
                    <Grid item xs={12} sm={12}>
                        <button
                            className="btn btn-primary"
                            type="button"
                            // endIcon={<EastIcon />}
                            style={{marginTop:'24px',marginLeft:'8px',backgroundColor:'#1565c0'}}
                        >
                            เพิ่มรายการ
                        </button>
                    </Grid>

      <button type="button" className="btn btn-primary mt-2 text-nowrap" onClick={getValueTest}>
        test get image
      </button>
                    */}

                    
                    <CameraAddMore btnText="เพิ่มรายการ" addTextLabel
                        onTextChange={handleTextChange}
                        onCapture={handleCapture}
                        onRemoveImage={handleRemoveImage}
                        previousData={dataStep.capturedImages?dataStep.capturedImages:null}
                        previousTextData={dataStep.capturedTextImages?dataStep.capturedTextImages:null}
                        previousObjID={dataStep.capturedObjIDImages?dataStep.capturedObjIDImages:null}
                        uploadAble={true}
                    />




                </Grid>


                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >

                    <Button onClick={handleBack}
                        sx={{ mt: 3, ml: 1, position: 'static' }}
                        // เดิมของ MUI เป็น position: 'relative' แล้วมันไปทับกับ position ของกล้อง
                    >
                        ย้อนกลับ
                    </Button>
                    <LoadingButton
                        variant="contained"
                        type="submit"
                        endIcon={<EastIcon />}
                        sx={{ mt: 3, ml: 1, position: 'static' }}
                        // เดิมของ MUI เป็น position: 'relative' แล้วมันไปทับกับ position ของกล้อง
                        loading={btnLoading}
                        loadingPosition="start"
                    >
                        ถัดไป
                    </LoadingButton>

                    {/*
                    <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                        ย้อนกลับ
                    </Button>

                    <LoadingButton
                        type="submit"
                        loading={isLoading}
                        loadingPosition="end"
                        endIcon={<EastIcon />}
                        variant="contained"
                        sx={{ mt: 3, ml: 1 }}
                    >
                        สมัคร
                    </LoadingButton> 
                    */}
                    
                </Box>
            </form>
        </React.Fragment>
    );
}
